import { css, SerializedStyles } from '@emotion/core';
import { Theme, normalText, titleText } from 'features/Theme';

const styles = {
  shadedRoundedContainer: (theme: Theme): SerializedStyles => css`
    ${normalText(theme)};
    background-color: #f2f7f8;
    padding: ${theme.mui.spacing(2)}px;
    border-radius: ${theme.shape.borderRadiusLarge}px;
    display: flex;
  `,

  hrContainer: (theme: Theme): SerializedStyles => css`
    margin-bottom: ${theme.mui.spacing(3)}px;
  `,

  bodyContainer: (theme: Theme): SerializedStyles => css`
    ${normalText(theme)};
    ul {
      padding-left: ${theme.mui.spacing(3)}px;
      padding-right: ${theme.mui.spacing(2)}px;

      li {
        margin-bottom: ${theme.mui.spacing(2)}px;
      }
    }
  `,

  cartIcon: (theme: Theme): SerializedStyles => css`
    height: ${theme.mui.spacing(3)}px;
    width: ${theme.mui.spacing(3)}px;
    margin-right: ${theme.mui.spacing(1)}px;
  `,

  checkoutTitle: (theme: Theme): SerializedStyles => css`
    font-weight: ${theme.mui.typography.fontWeightBold};
    padding-bottom: ${theme.mui.spacing(1)}px;
  `,

  pageTitleText: (theme: Theme): SerializedStyles => css`
    ${titleText(theme)}
    font-weight: 600;
    display: flex;
    align-items: center;
    margin-bottom: ${theme.mui.spacing(1)}px;
    svg {
      height: 45px;
      width: auto;
      margin-right: ${theme.mui.spacing(0.75)}px;
    }
  `,

  subtitleText: (theme: Theme): SerializedStyles => css`
    ${normalText(theme)};
  `,
};

export default styles;
